import client from './client';

export async function listWorkflowNotifications(status = 'active') {
  const { data } = await client.get('/workflow-notifications', { params: { status } });
  return data.data;
}

export async function workflowNotificationCount() {
  const { data } = await client.get('/workflow-notifications/count');
  return data.data.count;
}

export async function hideWorkflowNotification(id, remark) {
  const { data } = await client.post(`/workflow-notifications/${id}/hide`, { remark: remark || null });
  return data;
}
